import { NavLink, Route, Routes } from 'react-router-dom';
import { SearchPage } from '../features/search/SearchPage';
import { LibraryPage } from '../features/library/LibraryPage';
import { FolderDetailPage, FoldersPage } from '../features/folders/FoldersPage';
import { TitlePage } from '../features/title/TitlePage';
import './styles.css';

export function AppLayout() {
  return (
    <div className="layout">
      <Routes>
        <Route path="/" element={<SearchPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/folders" element={<FoldersPage />} />
        <Route path="/folders/:id" element={<FolderDetailPage />} />
        <Route path="/title/:mediaType/:tmdbId" element={<TitlePage />} />
      </Routes>

      <nav className="bottom-nav">
        <NavLink to="/" end>
          Поиск
        </NavLink>
        <NavLink to="/library">Мои списки</NavLink>
        <NavLink to="/folders">Папки</NavLink>
      </nav>
    </div>
  );
}
